module.exports = __webpack_public_path__ + "static/media/chevron_next.8f8ed5f9.svg";